import React from 'react';
import { Tag, Calendar, User } from 'lucide-react';

export const formatDate = (iso) => {
  if (!iso) return '';
  try {
    return new Date(iso).toLocaleDateString('en-AU', {
      day: 'numeric',
      month: 'long',
      year: 'numeric',
    });
  } catch {
    return '';
  }
};

export function PostMeta({ post }) {
  return (
    <>
      <div className="mt-6 flex flex-wrap items-center gap-2">
        {post.tags?.map((t) => (
          <span
            key={t}
            className="inline-flex items-center gap-1 rounded-full bg-violet-50 text-violet-700 px-2.5 py-1 text-[11px] uppercase tracking-[0.14em] font-medium"
          >
            <Tag size={10} /> {t}
          </span>
        ))}
      </div>
      <h1 className="mt-4 font-display text-[38px] md:text-[52px] leading-[1.05] font-semibold tracking-tight text-slate-900">
        {post.title}
      </h1>
      <div className="mt-4 flex flex-wrap items-center gap-4 text-[13.5px] text-slate-500">
        <span className="inline-flex items-center gap-1.5">
          <User size={13} /> {post.author}
        </span>
        <span className="inline-flex items-center gap-1.5">
          <Calendar size={13} /> {formatDate(post.published_at || post.created_at)}
        </span>
        {post.status === 'draft' && (
          <span className="inline-flex items-center gap-1 rounded-full bg-amber-100 text-amber-800 px-2 py-0.5 text-[11px] font-semibold uppercase tracking-wider">
            Draft
          </span>
        )}
      </div>
    </>
  );
}
